import { v4 } from 'uuid';
import NumberFormat from 'react-number-format';

export const acceptedVideo = [
  'video/mp4',
  'video/x-m4v',
  'video/webm',
  'video/quicktime',
  'video/x-msvideo',
  'video/x-ms-wmv',
];
export const acceptedImage = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/svg+xml',
  'image/webp',
];

export const uuid = () => v4()



export const RenderAmount = ({ price, ...props }) =>
  <>
    <NumberFormat
      displayType={'text'}
      decimalScale={0}
      fixedDecimalScale={price !== Math.floor(price)}
      thousandSeparator={"."}
      decimalSeparator=","
      value={price}
      suffix={'₫'}
      {...props}
    />
  </>

export const NumberInput = ({ value, onChange, ...rest }) =>
  <>
    <NumberFormat
      displayType={'input'}
      decimalScale={0}
      fixedDecimalScale={value !== Math.floor(value)}
      thousandSeparator={"."}
      decimalSeparator=","
      value={value}
      onValueChange={onChange}
      suffix={'₫'}
      {...rest}
    />
  </>



const ChuSo = new Array(
  " không ",
  " một ",
  " hai ",
  " ba ",
  " bốn ",
  " năm ",
  " sáu ",
  " bảy ",
  " tám ",
  " chín "
);
const Tien = new Array(
  "",
  " nghìn",
  " triệu",
  " tỷ",
  " nghìn tỷ",
  " triệu tỷ"
);

function DocSo3ChuSo(baso) {
  let tram;
  let chuc;
  let donvi;
  let KetQua = "";
  tram = parseInt(baso / 100);
  chuc = parseInt((baso % 100) / 10);
  donvi = baso % 10;
  if (tram == 0 && chuc == 0 && donvi == 0) return "";
  if (tram != 0) {
    KetQua += ChuSo[tram] + " trăm ";
    if (chuc == 0 && donvi != 0) KetQua += " linh ";
  }
  if (chuc != 0 && chuc != 1) {
    KetQua += ChuSo[chuc] + " mươi";
    if (chuc == 0 && donvi != 0) KetQua = KetQua + " linh ";
  }
  if (chuc == 1) KetQua += " mười ";
  switch (donvi) {
    case 1:
      if (chuc != 0 && chuc != 1) {
        KetQua += " mốt ";
      } else {
        KetQua += ChuSo[donvi];
      }
      break;
    case 5:
      if (chuc == 0) {
        KetQua += ChuSo[donvi];
      } else {
        KetQua += " lăm ";
      }
      break;
    default:
      if (donvi != 0) {
        KetQua += ChuSo[donvi];
      }
      break;
  }
  return KetQua;
}

export const docTienBangChu = (SoTien) => {
  let lan = 0;
  let i = 0;
  let so = 0;
  let KetQua = "";
  let tmp = "";
  let ViTri = new Array();
  if (SoTien < 0) return "Số tiền âm !";
  if (SoTien == 0) return "Không đồng !";
  if (SoTien > 0) {
    so = SoTien;
  } else {
    so = -SoTien;
  }
  if (SoTien > 8999999999999999) {
    //SoTien = 0;
    return "Số quá lớn!";
  }
  ViTri[5] = Math.floor(so / 1000000000000000);
  if (isNaN(ViTri[5])) ViTri[5] = "0";
  so = so - parseFloat(ViTri[5].toString()) * 1000000000000000;
  ViTri[4] = Math.floor(so / 1000000000000);
  if (isNaN(ViTri[4])) ViTri[4] = "0";
  so = so - parseFloat(ViTri[4].toString()) * 1000000000000;
  ViTri[3] = Math.floor(so / 1000000000);
  if (isNaN(ViTri[3])) ViTri[3] = "0";
  so = so - parseFloat(ViTri[3].toString()) * 1000000000;
  ViTri[2] = parseInt(so / 1000000);
  if (isNaN(ViTri[2])) ViTri[2] = "0";
  ViTri[1] = parseInt((so % 1000000) / 1000);
  if (isNaN(ViTri[1])) ViTri[1] = "0";
  ViTri[0] = parseInt(so % 1000);
  if (isNaN(ViTri[0])) ViTri[0] = "0";
  if (ViTri[5] > 0) {
    lan = 5;
  } else if (ViTri[4] > 0) {
    lan = 4;
  } else if (ViTri[3] > 0) {
    lan = 3;
  } else if (ViTri[2] > 0) {
    lan = 2;
  } else if (ViTri[1] > 0) {
    lan = 1;
  } else {
    lan = 0;
  }
  for (i = lan; i >= 0; i--) {
    tmp = DocSo3ChuSo(ViTri[i]);
    KetQua += tmp;
    if (ViTri[i] > 0) KetQua += Tien[i];
    if (i > 0 && tmp.length > 0) KetQua += ",";
  }
  if (KetQua.substring(KetQua.length - 1) == ",") {
    KetQua = KetQua.substring(0, KetQua.length - 1);
  }
  KetQua = KetQua.substring(1, 2).toUpperCase() + KetQua.substring(2) + ' đồng';
  KetQua = KetQua.replace(/ +(?= )/g, '');

  return KetQua;
}

export const INVOICE_TYPE = {
  E_VAT_INVOICE: 'E_VAT_INVOICE',
  E_VAT_INVOICE_AND_DELIVERY_NOTE: 'E_VAT_INVOICE_AND_DELIVERY_NOTE',
  NONE: 'NONE',
  DIRECT: 'DIRECT',
  PERSONAL_NON_VAT: 'PERSONAL_NON_VAT'
}

export const INVOICE_TYPE_NAME = {
  [INVOICE_TYPE.E_VAT_INVOICE_AND_DELIVERY_NOTE]: 'Hoá đơn VAT điện tử và Phiếu giao hàng',
  [INVOICE_TYPE.PERSONAL_NON_VAT]: 'Người tiêu dùng không có mã số thuế.'
}

// Cần hiển thị/nhập mã số thuế, tên công ty, địa chỉ hoá đơn, email nhận hoá đơn
export const INVOICE_TYPE_NEED_VAT_INFO = [
  INVOICE_TYPE.E_VAT_INVOICE,
  INVOICE_TYPE.E_VAT_INVOICE_AND_DELIVERY_NOTE
]

// Vẫn phải tính và cộng tiền thuế VAT vào đơn hàng (kể cả khi người mua không có mã số thuế)
export const INVOICE_TYPE_NEED_VAT_CALC = [
  INVOICE_TYPE.E_VAT_INVOICE,
  INVOICE_TYPE.E_VAT_INVOICE_AND_DELIVERY_NOTE,
  INVOICE_TYPE.PERSONAL_NON_VAT
]
export const INVOICE_TYPE_ARCHIVE_NAME = {
  [INVOICE_TYPE.DIRECT]: 'Hoá đơn bán hàng điện tử',
  [INVOICE_TYPE.E_VAT_INVOICE]: 'Hoá đơn VAT điện tử',
  [INVOICE_TYPE.NONE]: 'Phiếu giao hàng',
}

export const VAT_PERCENTS = [
  {
    name: '10',
    value: `10`,
  },
  {
    name: '8',
    value: '8',
  }
]

export const version = {
  admin: 'v1.0.0',
  storefront: 'v1.7.4'
}
